import angular from 'angular';
import collapse from 'angular-ui-bootstrap/src/collapse';
import dropdown from 'angular-ui-bootstrap/src/dropdown';
import modal from 'angular-ui-bootstrap/src/modal';
import typeahead from 'angular-ui-bootstrap/src/typeahead';
import accordion from 'angular-ui-bootstrap/src/accordion';
import tabs from 'angular-ui-bootstrap/src/tabs';
import tooltip from 'angular-ui-bootstrap/src/tooltip';
import progressbar from 'angular-ui-bootstrap/src/progressbar';
import datepicker from 'angular-ui-bootstrap/src/datepicker';
import datepickerPopup from 'angular-ui-bootstrap/src/datepickerPopup';

(function () {
    'use strict';

    angular.module('app.core', [
        'blocks.logger',
        // Liste des dépendances aux modules externes
        'ngMessages',
        'ngSanitize',
        'ngAnimate',
        'ngCookies',
        collapse,
        dropdown,
        modal,
        typeahead,
        accordion,
        progressbar,
        tabs,
        tooltip,
        datepicker,
        datepickerPopup,
        'ui.select', // dropdown
        'ui.router', // Router
        'ui.grid', // Grille
        'ui.grid.pagination',
        'ui.grid.selection',
        'ui.grid.i18n',
        'ui.grid.resizeColumns',
        'ui.grid.moveColumns',
        'ui.grid.exporter',
        'ui.grid.autoResize',
        'ui.tree', // Affichage d'arbre (drag'n'drop das lignes d'un tableau)
        'mgcrea.ngStrap.select', // Multi-selections
        'mgcrea.ngStrap.tooltip',
        'mgcrea.ngStrap.helpers.parseOptions',
        'ngFileUpload', // File upload
        'ngTagsInput', // Tags input
        'pascalprecht.translate', // Angular translate
        'toastr', // Toast
        'restangular', // Appel REST
        'angular-confirm',
        'angular-busy', // Indicateur de chargement
        'ngIdle',
    ]);
})();
